import { defineStore } from "pinia";
import apiService from "@/services/ApiService";
import { IMainInfo } from "@/modules/Dashboard/types";

export const useCommonStore = defineStore("commondStore", {
  state: () => ({
    data: {} as IMainInfo,
    loading: false,
    isSidebarOpen: false,
  }),
  actions: {
    fetchStaticPages() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        apiService
          .get<IMainInfo>("/common/static/")
          .then((response) => {
            this.data = response.data;
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
  },
});
